import { main } from './loader/bootstrap';

// IIFE entry point. The build wraps this in a self-executing function so the
// dealer's `<script>` tag runs it immediately with no module system on the host
// page. All logic lives in `core/bootstrap.ts` (and its imports) so it stays
// unit testable without triggering bootstrap on import.
main();
